import React from 'react';
import { BenefitsList } from '../../benefits';

export interface HitBenefitsProps {
  benefits: string[] | undefined | null;
  maxItems?: number;
  className?: string;
}

/**
 * Benefits section for Hit component
 * Wraps the shared BenefitsList component
 */
export const HitBenefits: React.FC<HitBenefitsProps> = ({
  benefits,
  maxItems = 3,
  className = '',
}) => {
  if (!benefits || benefits.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-col gap-1 justify-center mt-2 pb-2 min-w-0 ${className}`}>
      <BenefitsList benefits={benefits} maxItems={maxItems} />
    </div>
  );
};
